<template>
	<div>
		<AppButton
			:label="$t('settings.add-user')"
			startIcon="plus"
			@click="onAddUser"
			:loading="loading"
			:disabled="authStore.isAgentSubscriptionExpired"
		/>
	</div>
</template>

<script setup>
import { ref } from 'vue';
import { useCreateUserDialog } from '../../../stores/create-user-dialog';
import { abilities, useLimitationsStore } from '@/v2/modules/products/stores/limitations';
import { useAuthStore } from '@/v2/store/shared/auth-store';

const createUserDialogStore = useCreateUserDialog();
const limitationStore = useLimitationsStore();
const authStore = useAuthStore();

const loading = ref(false);

const onAddUser = async () => {
	loading.value = true;
	try {
		await limitationStore.checkLimitation(abilities.CreateUser);
		createUserDialogStore.open();
	} finally {
		loading.value = false;
	}
};
</script>

<style lang="scss" scoped></style>
